import { render, staticRenderFns } from "./Confirmacion.vue?vue&type=template&id=3f4ae125&scoped=true&"
import script from "./Confirmacion.vue?vue&type=script&lang=js&"
export * from "./Confirmacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4ae125",
  null
  
)

export default component.exports